import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LocalKeyMap } from '@/local';
import { isUserLogin } from "@/util";
import styles from './userLogin.module.scss'


const UserLogin = ({props}) => {
  const { t } = useTranslation();
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <>
      <div
        className={styles.iconChangeLanguage}
         onClick={()=>{
            navigate('/languageSwitch')
          }}></div>
      <div className={styles.iconUser}
        onClick={()=>{
          if (isUserLogin()) {
            navigate(`/?tab=my`)
          } else {
            navigate(`/login`)
          }
        }}></div>
    </>

  )
}

export default UserLogin
